export function buildJobHash(job) {

  return [
    job.title,
    job.company,
    job.city
  ]
    .join('_')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}